import script from "./ConfigClientView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigClientView.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigClientView.vue?vue&type=style&index=0&id=608b64e1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608b64e1"]])

export default __exports__